document.addEventListener('click', async (e) => {
  const btn = e.target.closest('.uploadkit-guard__fix');
  if (!btn) return;

  const guard = btn.closest('[data-uploadkit-guard]');
  if (!guard) return;

  const line = parseInt(guard.getAttribute('data-line') || '', 10);
  const qty = parseInt(guard.getAttribute('data-uploadcount') || '', 10);
  if (!Number.isFinite(line) || !Number.isFinite(qty)) return;

  try {
    // 1) Cambia el carrito vía AJAX (fiable)
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ line, quantity: qty })
    });

    if (!res.ok) throw new Error('Cart change failed');
    await res.json();

    // 2) Ayuda al theme a “enterarse”
    // Actualiza el input si existe y dispara evento change (muchos themes escuchan esto)
    const cartItem = document.querySelector(`.cart-item[data-line="${line}"]`);
    const qtyInput = cartItem?.querySelector('input.qty');
    if (qtyInput) {
      qtyInput.value = String(qty);
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
    }

    // 3) Dispara eventos típicos de refresco (por si Highlight escucha alguno)
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
    document.body.dispatchEvent(new CustomEvent('cart:refresh'));
    document.body.dispatchEvent(new CustomEvent('cart:updated'));
  } catch (err) {
    console.error(err);
  }
});
